<template>
  <Modal
    v-model="state"
    title="目标出价修改"
    width="568"
    class-name="c-modal vertical-center-modal"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="c-form">
      <Form :label-width="140">
        <FormItem label="激活出价" v-if="hasActive">
          <el-input-number
            :max="9999.99"
            :min="1"
            :precision="2"
            :controls="false"
            v-model.trim="landData.activeBid"
            placeholder="请输入激活出价"
            style="width: 240px"
            size="small"
            @blur="inputTrim('activeBid', landData.activeBid, landData, true, 2)"
          />
          <span>&nbsp;元</span>
          <Icon v-if="result.active_status" type="md-checkmark-circle" color="#09CD8E" size="24" style="margin-left: 8px" />
          <Icon v-if="result.active_status === false" type="ios-close-circle" color="#F1403C" size="24" style="margin-left: 8px" />
        </FormItem>
        <FormItem v-if="result.active_status === false">
          <span style="color: #f56c6c">{{ result.active_msg }}</span>
        </FormItem>
        <FormItem label="付费出价" v-if="hasPay">
          <el-input-number
            :max="9999.99"
            :min="1"
            :precision="2"
            :controls="false"
            v-model.trim="landData.payBid"
            placeholder="请输入付费出价"
            style="width: 240px"
            size="small"
            @blur="inputTrim('payBid', landData.payBid, landData, true, 2)"
          />
          <span>&nbsp;元</span>
          <Icon v-if="result.pay_status" type="md-checkmark-circle" color="#09CD8E" size="24" style="margin-left: 8px" />
          <Icon v-if="result.pay_status === false" type="ios-close-circle" color="#F1403C" size="24" style="margin-left: 8px" />
        </FormItem>
        <FormItem v-if="result.pay_status === false">
          <span style="color: #f56c6c">{{ result.pay_msg }}</span>
        </FormItem>
        <FormItem label="付费ROI" v-if="hasRoi">
          <el-input-number
            :max="1000"
            :min="0.0001"
            :precision="4"
            :controls="false"
            v-model.trim="landData.roiTarget"
            placeholder="请输入付费ROI"
            style="width: 240px"
            size="small"
            @blur="inputTrim('roiTarget', landData.roiTarget, landData, true, 2)"
          />
          <span>&nbsp;系数</span>
          <Icon v-if="result.roi_status" type="md-checkmark-circle" color="#09CD8E" size="24" style="margin-left: 8px" />
          <Icon v-if="result.roi_status === false" type="ios-close-circle" color="#F1403C" size="24" style="margin-left: 8px" />
        </FormItem>
        <FormItem v-if="result.roi_status === false">
          <span style="color: #f56c6c">{{ result.roi_msg }}</span>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button :disabled="loading" @click="closeModal">取消</Button>
        <Button type="primary" :loading="loading" @click="update">
          <span v-if="loading">保存中...</span>
          <span v-else>保存</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { isEmpty, trim, deepCopy } from '@/common/js/utils'
import { modifyAlladbid } from '@/api/convert.model'

const landData = {
  activeBid: '',
  payBid: '',
  roiTarget: ''
}

export default {
  name: 'bidModify',
  props: {
    value: {
      type: Boolean
    },
    info: {
      type: Object
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 默认初始化
    bindGetData(e) {
      if (e) {
        console.log(this.info)
        const { activeBid, payBid, roiRatio } = this.info
        if (activeBid > 0) this.hasActive = true
        if (payBid > 0) this.hasPay = true
        if (roiRatio && roiRatio.indexOf('%') > -1) this.hasRoi = true
        this.landData = { activeBid, payBid, roiTarget: this.hasRoi ? Number(roiRatio.split('%')[0]) : '' }
        return
      }
      this.landData = deepCopy(landData)
      this.hasActive = false
      this.hasPay = false
      this.hasRoi = false
      this.result = {}
    },
    update() {
      const params = {
        adAccountId: this.info.adAccountId,
        adId: this.info.adId
      }
      const { budget } = this.info
      Object.assign(params, JSON.parse(JSON.stringify(this.landData)))
      if (this.hasActive) {
        if (!params.activeBid) {
          this.$Message.warning('激活出价不可为空！')
          return
        } else if (params.activeBid >= budget) {
          this.$Message.warning('激活出价必须小于预算！')
          return
        }
      }
      if (this.hasPay) {
        if (!params.payBid) {
          this.$Message.warning('付费出价不可为空！')
          return
        } else if (params.payBid >= budget) {
          this.$Message.warning('付费出价必须小于预算！')
          return
        }
      }
      if (this.hasRoi && !params.roiTarget) {
        this.$Message.warning('Roi系数不可为空！')
        return
      }
      if (this.hasActive && this.hasPay && params.activeBid > params.payBid) {
        this.$Message.warning('激活出价必须小于付费出价！')
        return
      }
      this.loading = true
      modifyAlladbid(params).then((data) => {
        this.loading = false
        if (data) {
          this.result = data
          const { active_status, pay_status, roi_status } = data
          if (active_status !== false && pay_status !== false && roi_status !== false) {
            this.closeModal()
            this.$emit('on-refresh')
          }
        } else this.$Message.error('修改失败')
      })
    },
    inputTrim(key, val, obj, fixed, precision = 2) {
      if (isEmpty(val)) return val
      val = Number(trim(val))
      if (fixed) {
        val = val.toFixed(precision)
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    closeModal() {
      this.$emit('input', false)
    }
  },
  data() {
    return {
      loading: false,
      landData: deepCopy(landData),
      hasActive: false,
      hasPay: false,
      hasRoi: false,
      result: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.c-form {
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: left;
  margin-bottom: 8px;

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
    text-align: left;
    margin-bottom: 8px;
  }
}

::v-deep .el-input__inner {
  text-align: left;
}
</style>
